module.exports = __webpack_public_path__ + "static/Peryton-a88420a04c5452dd34466cfda3bd530f.jpg";